import { render, staticRenderFns } from "./MasterWilayah.vue?vue&type=template&id=a1556500&scoped=true&"
import script from "./MasterWilayah.vue?vue&type=script&lang=js&"
export * from "./MasterWilayah.vue?vue&type=script&lang=js&"
import style0 from "./MasterWilayah.vue?vue&type=style&index=0&id=a1556500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1556500",
  null
  
)

export default component.exports